export interface SocialProofCard {
  id: string
  initials: string
  name: string
  role: string
  quote: string
  packageBadge: string
}

export interface SocialProofStat {
  id: string
  value: string
  label: string
}

export const socialProofCards: SocialProofCard[] = [
  {
    id: 'miguel',
    initials: 'MR',
    name: 'Miguel R.',
    role: 'Techador · Indiana',
    quote: 'La primera semana 4 cotizaciones nuevas. Un contrato pagó mi web 10 veces.',
    packageBadge: 'Paquete $600',
  },
  {
    id: 'maria',
    initials: 'DM',
    name: 'Dra. María G.',
    role: 'Dentista · Chicago',
    quote: '9 pacientes nuevos en 3 semanas. Todos me encontraron en Google.',
    packageBadge: 'Paquete $1,200',
  },
  {
    id: 'juan',
    initials: 'JV',
    name: 'Juan V.',
    role: 'Landscaping · Texas',
    quote: 'Antes dependía del boca a boca. Ahora mi agenda está llena sola.',
    packageBadge: 'Paquete $600',
  },
]

export const socialProofStats: SocialProofStat[] = [
  { id: 'negocios', value: '100+', label: 'negocios con web activa' },
  { id: 'dias', value: '7', label: 'días promedio de entrega' },
  { id: 'rating', value: '5★', label: 'calificación promedio' },
]
